<template>
  <div class="properties-form">
    <div class="properties-form-item">
      <div class="label">名称</div>
      <div class="form-item">
        <a-input
          v-model:value="elementName"
          @pressEnter="setElementName"
          @blur="setElementName"
        />
      </div>
    </div>
    <div class="properties-form-block"></div>
    <div
      v-for="(item, itemIndex) in outPortData"
      :key="itemIndex"
      class="properties-form-item"
    >
      <div class="label">输出{{ itemIndex + 1 }}</div>
      <div class="form-item out-port-form-item">
        <a-select
          v-model:value="outPortData[itemIndex]['targetPortId']"
          @change="(portId) => changeOutPortConnect(portId, item, itemIndex)"
        >
          <a-select-option
            v-for="canConnectInPort in canConnectInPortsList"
            :key="canConnectInPort.portId"
            :value="canConnectInPort.portId"
          >
            {{ canConnectInPort.name }}
          </a-select-option>
        </a-select>
        <a-tooltip v-if="outPortData.length > 1" placement="bottom">
          <template #title>删除节点</template>
          <MinusCircleOutlined @click="removeOutPortInfo(itemIndex)" />
        </a-tooltip>
      </div>
    </div>
    <div class="properties-form-block"></div>
    <div class="properties-form-item">
      <div class="label">输入类型</div>
      <div class="form-item full-select">
        <a-select
          v-model:value="elementFormValues.inputType"
          @change="setElementValue('inputType')"
        >
          <a-select-option value="constant">常量</a-select-option>
          <a-select-option value="device">设备输入</a-select-option>
          <a-select-option value="enumeration">枚举</a-select-option>
        </a-select>
      </div>
    </div>
    <div
      v-if="elementFormValues.inputType === 'constant'"
      class="properties-form-item"
    >
      <div class="label">常量值</div>
      <div class="form-item">
        <a-input-number
          :precision="0"
          v-model:value="elementFormValues.constantValue"
          @blur="setElementValue('constantValue')"
          @keyup.enter="setElementValue('constantValue')"
        ></a-input-number>
      </div>
    </div>
    <div
      v-if="elementFormValues.inputType === 'device'"
      class="properties-form-item"
    >
      <div class="label">物模型</div>
      <div class="form-item full-select">
        <a-select
          v-model:value="elementFormValues.thingsModalId"
          @change="handleThingsModalIdChange"
        >
          <a-select-option
            v-for="thingsModel in thingsModelList"
            :key="thingsModel.id"
            :value="thingsModel.id"
            >{{ thingsModel.modelName }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div
      v-if="elementFormValues.inputType === 'device'"
      class="properties-form-item"
    >
      <div class="label">属性</div>
      <div class="form-item full-select">
        <a-select
          v-model:value="elementFormValues.modelPropertyId"
          @change="handleModelPropertyIdChange"
        >
          <a-select-option
            v-for="modelProperty in modelPropertyList"
            :key="modelProperty.id"
            :value="modelProperty.id"
            >{{ modelProperty.name }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div
      v-if="elementFormValues.inputType === 'device'"
      class="properties-form-item"
    >
      <div class="label">设备</div>
      <div class="form-item full-select">
        <a-select
          v-model:value="elementFormValues.modelPropertyDeviceId"
          @change="setElementValue('modelPropertyDeviceId')"
        >
          <a-select-option
            v-for="modelPropertyDevice in modelPropertyDeviceList"
            :key="modelPropertyDevice.id"
            :value="modelPropertyDevice.id"
            >{{ modelPropertyDevice.name }}</a-select-option
          >
        </a-select>
      </div>
    </div>
    <div
      v-if="elementFormValues.inputType === 'enumeration'"
      class="properties-form-item"
    >
      <div class="label">枚举</div>
      <div class="form-item full-select">
        <a-select
          v-model:value="elementFormValues.enumerationId"
          @change="setElementValue('enumerationId')"
        >
          <a-select-option
            v-for="enumeration in enumerationsList"
            :key="enumeration.id"
            :value="enumeration.id"
            >{{ enumeration.ruleTagName }}</a-select-option
          >
        </a-select>
      </div>
    </div>
  </div>
</template>

<script>
import * as R from "ramda";
import { message } from "ant-design-vue";
import { MinusCircleOutlined } from "@ant-design/icons-vue";
import {
  thingsModelPage,
  modelPropertyPage,
  modelPropertyDevicePage,
  enumerationList,
} from "@/api";

export default {
  components: {
    MinusCircleOutlined,
  },
  props: {
    elementView: Object,
    elementDataName: String,
    elementDataStateData: Object,
    elementDataMethods: Object,
  },
  data() {
    return {
      elementName: "",
      elementFormValues: {},

      inPortData: [],
      preInPortData: [],

      outPortData: [],
      preOutPortData: [],

      canConnectInPortsList: [],
      canConnectOutPortsList: [],

      thingsModelList: [],
      modelPropertyList: [],
      modelPropertyDeviceList: [],

      enumerationsList: [],
    };
  },
  mounted() {
    this.init();
    this.initPropertiesFormListener();
  },
  methods: {
    init() {
      this.elementName = this.elementDataName;
      this.elementFormValues = R.clone(this.elementDataStateData);
      this.getInData();
      this.getOutData();
      this.getCanConnectInPortsList();
      this.getCanConnectOutPortsList();

      this.getThingsModelPage().then(() => {
        if (this.elementFormValues.thingsModalId) {
          this.getModelPropertyPage(this.elementFormValues.thingsModalId).then(
            () => {
              if (this.elementFormValues.modelPropertyId) {
                this.getModelPropertyDevicePage(
                  this.elementFormValues.modelPropertyId
                );
              }
            }
          );
        }
      });
      this.getEnumerationList();
    },
    initPropertiesFormListener() {
      this.elementDataMethods.addPropertiesFormListener(() => {
        this.init();
      });
    },
    setElementName() {
      this.elementDataMethods.setElementName(this.elementName);
    },
    addInPort() {
      this.elementDataMethods.addInPort();
    },
    getInData() {
      const inData = this.elementDataMethods.getInData();
      this.inPortData = R.clone(inData);
      this.preInPortData = R.clone(inData);
    },
    getOutData() {
      const outData = this.elementDataMethods.getOutData();
      this.outPortData = R.clone(outData);
      this.preOutPortData = R.clone(outData);
    },
    getCanConnectOutPortsList() {
      const canConnectOutPortsList =
        this.elementDataMethods.getCanConnectOutPortsList();
      this.canConnectOutPortsList = canConnectOutPortsList;
    },
    getCanConnectInPortsList() {
      const canConnectInPortsList =
        this.elementDataMethods.getCanConnectInPortsList();
      this.canConnectInPortsList = canConnectInPortsList;
    },
    changeInPortConnect(portId, inPortInfoItem, index) {
      const {
        canConnectOutPortsList,
        elementDataMethods,
        inPortData,
        preInPortData,
      } = this;

      let isOtherPortConnected = false;
      let conncetedInPortInfoItem = null;
      let conncetedInPortInfoItemIndex = null;

      for (let i = 0; i < preInPortData.length; i++) {
        let tmpInPortInfoItem = preInPortData[i];
        if (tmpInPortInfoItem.sourcePortId === portId) {
          isOtherPortConnected = true;
          conncetedInPortInfoItem = tmpInPortInfoItem;
          conncetedInPortInfoItemIndex = i;
          break;
        }
      }

      if (isOtherPortConnected) {
        console.log("isOtherPortConnected", isOtherPortConnected);

        elementDataMethods.swapInPortsLink(
          preInPortData[index],
          conncetedInPortInfoItem
        );
        const preInPortDataClone = R.clone(preInPortData);
        const conncetedInPortInfoItemClone = R.clone(conncetedInPortInfoItem);

        ["sourcePortId", "sourceCellId", "linkId"].map((key) => {
          preInPortDataClone[index][key] = conncetedInPortInfoItemClone[key];
          preInPortDataClone[conncetedInPortInfoItemIndex][key] =
            preInPortData[index][key];
        });

        this.preInPortData = R.clone(preInPortDataClone);
        this.inPortData = R.clone(preInPortDataClone);
      } else {
        const connectPortInfo = canConnectOutPortsList.find(
          (item) => item.portId === portId
        );
        const linkId = elementDataMethods.changeInPortConnect(
          connectPortInfo,
          inPortInfoItem
        );
        const inPortDataClone = R.clone(inPortData);
        inPortDataClone[index].sourceCellId = connectPortInfo.cellId;
        inPortDataClone[index].sourcePortId = connectPortInfo.portId;
        inPortDataClone[index].linkId = linkId;

        this.preInPortData = R.clone(inPortDataClone);
        this.inPortData = R.clone(inPortDataClone);
      }
    },
    changeOutPortConnect(portId, outPortInfoItem, index) {
      const {
        canConnectInPortsList,
        elementDataMethods,
        outPortData,
        preOutPortData,
      } = this;

      let isOtherPortConnected = false;
      let conncetedOutPortInfoItem = null;
      let conncetedOutPortInfoItemIndex = null;

      for (let i = 0; i < preOutPortData.length; i++) {
        let tmpOutPortInfoItem = preOutPortData[i];
        if (tmpOutPortInfoItem.targetPortId === portId) {
          isOtherPortConnected = true;
          conncetedOutPortInfoItem = tmpOutPortInfoItem;
          conncetedOutPortInfoItemIndex = i;
          break;
        }
      }

      if (isOtherPortConnected) {
        elementDataMethods.swapInPortsLink(
          preOutPortData[index],
          conncetedOutPortInfoItem
        );
        const preOutPortDataClone = R.clone(preOutPortData);
        // const outPortInfoItemClone = R.clone(preOutPortData[index]);
        const conncetedOutPortInfoItemClone = R.clone(conncetedOutPortInfoItem);

        ["targetPortId", "targetCellId", "linkId"].map((key) => {
          preOutPortDataClone[index][key] = conncetedOutPortInfoItemClone[key];
          preOutPortDataClone[conncetedOutPortInfoItemIndex][key] =
            preOutPortData[index][key];
        });

        this.preOutPortData = R.clone(preOutPortDataClone);
        this.outPortData = R.clone(preOutPortDataClone);
      } else {
        const connectPortInfo = canConnectInPortsList.find(
          (item) => item.portId === portId
        );
        const linkId = elementDataMethods.changeOutPortConnect(
          connectPortInfo,
          outPortInfoItem
        );
        const outPortDataClone = R.clone(outPortData);
        outPortDataClone[index].targetCellId = connectPortInfo.cellId;
        outPortDataClone[index].targetPortId = connectPortInfo.portId;
        outPortDataClone[index].linkId = linkId;

        this.preOutPortData = R.clone(outPortDataClone);
        this.outPortData = R.clone(outPortDataClone);
      }
    },
    addInData() {
      const inPortDataClone = R.clone(this.inPortData);
      inPortDataClone.push(this.elementDataMethods.createInData());
      this.inPortData = inPortDataClone;
    },
    addOutData() {
      const outPortDataClone = R.clone(this.outPortData);
      outPortDataClone.push(this.elementDataMethods.createOutData());
      this.outPortData = outPortDataClone;
    },
    removeInPortInfo(index) {
      const { inPortData, elementDataMethods } = this;
      let inPortDataClone = R.clone(inPortData);
      if (inPortDataClone.length > 1) {
        inPortDataClone = R.remove(index, 1, inPortDataClone);
        elementDataMethods.removeInLink(inPortData[index]);
        elementDataMethods.removeInPort(inPortData[index].targetPortId);
      } else {
        const tmp = R.clone(inPortDataClone[0]);
        if (inPortDataClone[0].linkId) {
          elementDataMethods.removeInLink(inPortDataClone[0]);
        }
        tmp.sourcePortId = "";
        tmp.sourceCellId = "";
        tmp.linkId = "";
        inPortDataClone[0] = tmp;
      }
      this.preInPortData = R.clone(inPortDataClone);
      this.inPortData = R.clone(inPortDataClone);
    },
    removeInPortLink(index) {
      const { inPortData, elementDataMethods } = this;
      let inPortDataClone = R.clone(inPortData);
      if (inPortDataClone.length > 1) {
        // inPortDataClone = R.remove(index, 1, inPortDataClone);
        inPortDataClone[index].sourcePortId = "";
        inPortDataClone[index].sourceCellId = "";
        inPortDataClone[index].linkId = "";

        elementDataMethods.removeInLink(inPortData[index]);
      } else {
        const tmp = R.clone(inPortDataClone[0]);
        if (inPortDataClone[0].linkId) {
          elementDataMethods.removeInLink(inPortDataClone[0]);
        }
        tmp.sourcePortId = "";
        tmp.sourceCellId = "";
        tmp.linkId = "";
        inPortDataClone[0] = tmp;
      }

      this.preInPortData = R.clone(inPortDataClone);
      this.inPortData = R.clone(inPortDataClone);
    },
    removeOutPortInfo(index) {
      const { outPortData, elementDataMethods } = this;
      let outPortDataClone = R.clone(outPortData);
      if (outPortDataClone.length > 1) {
        outPortDataClone = R.remove(index, 1, outPortDataClone);
        elementDataMethods.removeOutLink(outPortData[index]);
      } else {
        const tmp = R.clone(outPortDataClone[0]);
        if (outPortDataClone[0].linkId) {
          elementDataMethods.removeOutLink(outPortDataClone[0]);
        }
        tmp.targetPortId = "";
        tmp.targetCellId = "";
        tmp.linkId = "";
        outPortDataClone[0] = tmp;
      }
      this.preOutPortData = R.clone(outPortDataClone);
      this.outPortData = R.clone(outPortDataClone);
    },
    setElementValue(key) {
      const { elementFormValues, elementDataMethods } = this;
      elementDataMethods.setData(key, elementFormValues[key]);
    },
    getThingsModelPage() {
      return new Promise((resolve, reject) => {
        const params = { isPage: 0 };
        thingsModelPage.request(params).then((result) => {
          if (result.bizCode === 1) {
            this.thingsModelList = result.data.items;
            resolve();
          } else {
            reject();
            message.warning(result.bizRemind, 4);
          }
        });
      });
    },
    getEnumerationList() {
      return new Promise((resolve, reject) => {
        const params = { isPage: 0 };
        enumerationList.request(params).then((result) => {
          if (result.bizCode === 1) {
            resolve();
            this.enumerationsList = result.data.items;
          } else {
            reject();
            message.warning(result.bizRemind, 4);
          }
        });
      });
    },
    handleThingsModalIdChange() {
      const elementFormValuesClone = R.clone(this.elementFormValues);
      elementFormValuesClone.modelPropertyId = undefined;
      elementFormValuesClone.modelPropertyDeviceId = undefined;

      this.elementFormValues = elementFormValuesClone;
      this.modelPropertyList = [];
      this.modelPropertyDeviceList = [];

      this.setElementValue("thingsModalId");
      this.setElementValue("modelPropertyId");
      this.setElementValue("modelPropertyDeviceId");

      this.getModelPropertyPage(this.elementFormValues.thingsModalId);
    },
    getModelPropertyPage(thingsModalId) {
      return new Promise((resolve, reject) => {
        const params = { isPage: 0, modelId: thingsModalId };
        modelPropertyPage.request(params).then((result) => {
          if (result.bizCode === 1) {
            this.modelPropertyList = result.data.items;
            resolve();
          } else {
            reject();
            message.warning(result.bizRemind, 4);
          }
        });
      });
    },
    handleModelPropertyIdChange() {
      const elementFormValuesClone = R.clone(this.elementFormValues);
      elementFormValuesClone.modelPropertyDeviceId = undefined;

      this.elementFormValues = elementFormValuesClone;
      this.modelPropertyDeviceList = [];

      this.setElementValue("modelPropertyId");
      this.setElementValue("modelPropertyDeviceId");

      this.getModelPropertyDevicePage(this.elementFormValues.modelPropertyId);
    },
    getModelPropertyDevicePage(modelPropertyId) {
      return new Promise((resolve, reject) => {
        const params = { isPage: 0, modelPropertyId };
        modelPropertyDevicePage.request(params).then((result) => {
          if (result.bizCode === 1) {
            this.modelPropertyDeviceList = result.data.items;
            resolve();
          } else {
            reject();
            message.warning(result.bizRemind, 4);
          }
        });
      });
    },
  },
  watch: {
    elementView: {
      handler() {
        // if (!R.equals(newValue.elementName, oldValue.elementName)) {
        //   this.elementName = newValue.elementName;
        // }
        this.init();
      },
      // deep: true,
    },
  },
};
</script>
